<template>
  <div class="reservation__address">
    <img src="/images/address_info_marker.svg"></img>
    {{ address }}
  </div>
</template>

<script>
  export default {
    name: "ReservationAddress",
    props: {
      address: {
        required: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/reservation/ReservationAddress.vue